/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:07/10/2021
 @Time:08:34
 **/

export default class BegroFile extends Blob
{

    /**
     * @type {string} file UUID
     */
    #_id;

    /**
     * id temporaire coté serveur généralement aprés un upload et attente de sauvegarde permanent
     * @type {?String}
     * @private
     */
    #_temporaryID=null;

    /**
     * @type{String} le type de continu MIME Type exemple application/json
     */
    #_type;


    /**
     * @type{String} le nom de fichier
     */
    #_name;


    /**
     * @type {number} La taille de fichier en octet
     */
    #_size;


    /**
     * @type {String} extension de fichier
     */
    #_extension;

    /**
     * @type {Date} la date de creation de fichier
     */
    #_creationDate;

    /**
     * @type{String} URL Basic la partie fixe de URL exemple societe/depense
     */
     #_baseURL=null;


    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }


    get type() {
        return this.#_type;
    }

    set type(value) {
        this.#_type = value;
    }

    get name() {
        return this.#_name;
    }

    set name(value) {
        this.#_name = value;
    }

    get size() {
        return this.#_size;
    }

    set size(value) {
        this.#_size = value;
    }

    get extension() {
        return this.#_extension;
    }

    set extension(value) {
        this.#_extension = value;
    }

    get creationDate() {
        return this.#_creationDate;
    }

    set creationDate(value) {
        this.#_creationDate = value;
    }


    get baseURL() {
        return this.#_baseURL;
    }

    set baseURL(value) {
        this.#_baseURL = value;
    }



    get temporaryID() {
        return this.#_temporaryID;
    }

    set temporaryID(value) {
        this.#_temporaryID = value;
    }

    /**
     * indique si le fichier est un fichier temporaire ou sauvegardé coté serveur
     * @return {boolean}
     */
    isTemporaryFile()
    {
        return this.#_id==null;
    }

    /**
     * Retourne URL de fichier sur le serveur
     * @return {string}
     */
    url() {
        if(typeof this.baseURL!=null) {
            if(this.getFileURLFileType()!=null) {
                return Begro.getURL(this.baseURL + "/file/" + this.getFileURLFileType() + "/" + this.id+'/download');
            }else{
                Begro.logError("Le type de fichier nécessaire  pour la récupération de fichier"+this.name+" doit être définit ");
            }
        }
        else{
            Begro.logError("Le base url pour récupération de fichier doit être définit");
        }
    }

    /**
     * le type de fichier qu sera injecté dans url pour download ou delete qui doit être le même que le type fichier utilisé dans l'énumération dans la classe FileService Java
     * @return {?string}
     */
    getFileURLFileType()
    {
        return null;
    }

    /**
     * Créer une instance js depuis format json
     * @param {{} }jsonFile json file
     * @param {BegroFile?} file  instance de la classe qui éténdre cette classe de base
     * @return {BegroFile}
     */
    static createFromJson(jsonFile,file=null)
    {
        if(file===null)
        {
           file=new BegroFile();
        }
        file.id=jsonFile.id;
        file.name=jsonFile.name;
        file.extension=jsonFile.extension;
        file.creationDate=new Date(jsonFile.creationDate);
        file.size=jsonFile.size;
        file.temporaryID=jsonFile.temporaryID;
        file.type=jsonFile.contentType;
        Begro.logInfo("Le fichier ayant id "+file.id+" a été crée avec succès depuis objet json");
        Begro.logInfo("Objet json",jsonFile);
        Begro.logInfo("Objet BegroFile javascript crée :",file);
        return file;
    }

}